import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-green-400 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-green-300 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="text-green-400 text-xs uppercase tracking-widest mb-2 block">Depoimentos</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white uppercase leading-none">
            O QUE NOSSOS<br />CLIENTES DIZEM
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 flex flex-col gap-5 hover:border-green-500/30 transition-all duration-300"
            >
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <p className="text-gray-300 text-sm leading-relaxed flex-1">{t.text}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-green-500/30">
                  <img alt={t.name} className="w-full h-full object-cover" src={t.avatar} loading="lazy" decoding="async" />
                </div>
                <div>
                  <p className="text-white font-black text-sm uppercase">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
